<template>
    <div class="container mb-3">
        <div class="row pt-4">
            <div class="col-12 elementscartcouponForm p-2">
                <div class="content2">
                    <div class="fields">
                        
                        
                        <div class="elementsorderSummaryinfoFi">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark">Sous Total</div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ cart.lines.cartSubTotal }}</div>
                                </div>
                            </div>
                        </div>


                        <div class="elementsorderSummaryinfoFi1">
                            <div class="content5">
                                <div class="titleamount ">
                                    <div class="label1 text-dark">Total</div>
                                    <div class="value1 text-dark">{{ cart.lines.cartTotal }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="cart.lines.giftCardAmount" class="elementsorderSummaryinfoFi">
                            <div class="content5 mt-2">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark">{{ $t('giftCard.payment') }}


                                            <div v-if="cart.lines.giftCardDiscountedItemsWarning" class="tooltip-container">
                                                <img  alt="" width="15px" class="" src="@/assets/icons/info.svg"   @mouseover="showGiftCardWarningTootltip=true" @mouseleave="showGiftCardWarningTootltip=false" />  

                                                <div v-if="showGiftCardWarningTootltip && cart.lines.giftCardDiscountedItemsWarning"  class="tooltip">Le code promo ne s'applique pas sur les articles soldés</div>
                                            </div>
                                        



                                        </div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ cart.lines.giftCardAmount }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="cart.lines.finalAmountToPay" class="elementsorderSummaryinfoFi1">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark font-weight-bold">Net à payer </div>
                                    </div>
                                    <div class="value font-weight-normal text-dark font-weight-bold">{{ cart.lines.finalAmountToPay }}</div>
                                </div>
                            </div>
                        </div>



                    </div>

                    <div v-if="showError" class="text-danger itemNotPersonalised font-weight-bold "> 
                        {{ countItemNotPersonalised }}
                        {{countItemNotPersonalised == 1 ? ' article n\'est pas encore personnalisé' : ' articles ne sont pas encore personnalisés'}}
                    </div>

                        <div class="button1 font-weight-bold mb-2" @click="goToCartView">Voir mon panier</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script >
export default ({
    name: "ElementsCartCartSummary",

    components: {},
    props: {
        deliveryModes:{
            type: Array
        },

        cart:{
            type: Object
        },
    },


    data() {
        return {
            showError:false,

            showDiscountTootltip: false,
            showGiftCardWarningTootltip: false,

            giftCard:{code:null},
        };
    },

    watch: {
        deliveryModes: function() {
            this.selectedDeliveryMode = this.deliveryModes[0];
        },
    },

    methods: {

        goToCartView(){
            if (this.countItemNotPersonalised > 0) {
                this.showError = true;
                
                setTimeout(() => {
                    this.showError = false;
                }, 3000);
            }
            else {
                this.$router.push({ path: "/panier" });
            }

        },
    


    },

    computed: {
        cartItems() {
            return  this.cart && this.cart.lines ? this.cart.lines.list : [];
        },

        countItemNotPersonalised(){
            return this.cartItems.filter(item => !item.isAlreadyPersonalised).length
        }
        
    }
})
</script>
<style scoped>

.itemNotPersonalised{
    align-self: flex-end;

}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 9999;
  opacity: 0.9;
  font-size:14px;
  display: inline-block;
}

.addYourCode1 {
    align-self: stretch;
    position: relative;
    font-size: 16px;
    line-height: 26px;
    color: #605f5f;
}

.title {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 7px;
}

.codeInput {
    flex: 1;
    height: 100%;
    /* Take up the full height of the parent container */
    border: none;
    outline: none;
    font-size: 16px;
}

.iconinput {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.getStarted {
    position: relative;
    line-height: 24px;
    font-weight: 500;
    cursor: pointer;
}

.content1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    color: #121212;
    /* font-family: 'Space Grotesk'; */
}

.input {
    align-self: stretch;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    height: 52px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 16px;
    gap: 8px;

    max-width:400px;
}

.formInput {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

.form {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 16px;
    color: #605f5f;
}

.elementscartcouponForm {
    width: 100%;
    border: 1px solid #ddd;
    border-radius:8px;
}

.cartSummary {
    align-self: stretch;
    position: relative;
    line-height: 34px;
    font-weight: 500;
    font-size: 22px;
    color: #121212;
}

.radioButtonIcon1 {
    position: relative;
    border-radius: 100px;
    width: 19px;
    height: 19px;
}

.freeShipping {
    position: relative;
    line-height: 26px;
}


.radioButton3 {
    position: relative;
    border-radius: 100px;
    border: 1px solid #121212;
    box-sizing: border-box;
    width: 19px;
    height: 19px;
}


.title1 {
    position: absolute;
    top: calc(50% - 13px);
    left: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.value {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    line-height: 26px;
    font-weight: 600;
    text-align: right;
}

.titleamount {
    flex: 1;
    position: relative;
    height: 26px;
}

.content5 {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.elementsorderSummaryinfoFi {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

.label1 {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 30px;
    font-weight: 600;
}

.value1 {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    text-align: right;
}

.elementsorderSummaryinfoFi1 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 18px;
}

.fields {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 10px;
}

.getStarted1 {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-weight: 500;
}

.button1 {
    align-self: stretch;
    border-radius: 6px;
    background-color: #121212;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 26px;
    cursor: pointer;
    text-align: center;
    font-size: 18px;
    color: #fff;
    /* font-family: 'Space Grotesk'; */
}

.content2 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    /*font-size: 16px;*/
}

.elementscartsummary {
    position: absolute;
    top: 0px;
    left: 569px;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    width: 538px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px;
    gap: 16px;
}

.content {
    position: relative;
    width: 1107px;
    height: 418px;
}

@media (max-width: 768px) {
    .content {
        width: 150%;
        height: auto;
    }
}
</style>